import { useHookstate } from "@hookstate/core"
import { FileUploadWithPreview } from "../../../components/FileUploadWithPreview"
import { getDateOnly, showSnackbar } from "../../../misc/utils"
import UploadFile from "../../../assets/icons/UploadFile"
import { ChangeEvent } from "react"
import ArrowLeft from "../../../assets/icons/ArrowLeft"
import DefaultButton from "../../../components/default-button/DefaultButton"
import Tick from "../../../assets/icons/Tick"
import { simpleGetter } from "../../../actions/common"
import { lessonsApi } from "../../../api/api"

type LessonAdditionalMaterialProps = {
    lesson: any,
    onClose: () => void,
    onSuccess: () => void
}

export const LessonAdditionalMaterial = ({ lesson, onClose, onSuccess }: LessonAdditionalMaterialProps) => {
    const localState = useHookstate({
        form: {
            additional_files: {}
        }
    });
    const state: Record<string, any> = localState.get();
    const form = state.form || {};

    const addAdditionalFile = () => {
        const now = new Date().getTime()
        //@ts-ignore
        localState.form.additional_files[now].set('')
    }

    const onFormAdditionalFileChange = (key: string) => (f: ChangeEvent<HTMLInputElement>) => {
        if (f.target.files?.length) {
            //@ts-ignore
            localState.form.additional_files[key].set(f.target.files[0]);
        }
    }

    const onFormAdditionalFileChangeRaw = (key: string) => (value: File | null) => {
        //@ts-ignore
        localState.form.additional_files[key].set(value);
    }

    const onSubmit = async () => {
        const formData = new FormData();
        formData.append('type', 'multiple')
        formData.append('lesson_id', lesson.id)
        for (const additionalFile in form.additional_files) {
            if (form.additional_files[additionalFile]) {
                formData.append(`additional_${additionalFile}`, form.additional_files[additionalFile])
            }
        }
        const response = await simpleGetter(lessonsApi.uploadMedia, formData)
        if (response.success) {
            onSuccess()
            showSnackbar('Успешно', 'success')
            onClose()
        }
    }

    return (
        <div className="flex flex-col flex-1 overflow-y-auto">
            <div>
                <p className="font-normal text-[15px] text-[#5F6B88]">
                    Дополнительный материал урока
                </p>
                <p className="text-black font-normal text-[24px]">
                    {getDateOnly(lesson.start_time)}
                </p>
            </div>
            <div className="flex flex-col gap-8 overflow-y-auto flex-1 my-8">
                <div className="flex flex-col flex-1 overflow-y-auto gap-2">
                    <p className="text-[#5F6B88] font-medium text-sm">Дополнительные материалы</p>
                    <div className="flex flex-col flex-1 gap-2 overflow-y-auto rounded-lg border border-valley-light-gray p-4">
                        {Object.keys(form.additional_files).filter(k => form.additional_files[k] !== null).map(k => (
                            <FileUploadWithPreview wrapperClassName="flex-none" mode="edit" value={form.additional_files[k]} updateValueRaw={onFormAdditionalFileChangeRaw(k)} handleChange={onFormAdditionalFileChange(k)} />
                        ))}
                    </div>
                    <button onClick={addAdditionalFile} className={`flex flex-row gap-2 justify-center items-center py-3 rounded-md border border-valley-main text-valley-main cursor-pointer`}>
                        <UploadFile />
                        <span className="text-[15px] font-semibold leading-[18px]">
                            Загрузить дополнительные материалы
                        </span>
                    </button>
                </div>
            </div>
            <div className="flex flex-row gap-3">
                <DefaultButton
                    buttonText="Вернуться"
                    additionalStyle="flex-1 bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
                    Icon={ArrowLeft}
                    onClick={onClose}
                />
                <DefaultButton
                    buttonText="Сохранить"
                    additionalStyle="flex-1 bg-valley-dark-green text-white px-8 py-3 text-nowrap"
                    Icon={Tick}
                    onClick={onSubmit}
                />
            </div>
        </div>
    )
}